import { createFileRoute } from "@tanstack/react-router";

import {
  guardStatementExtractionFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction",
)({
  beforeLoad: ({ context: { active }, params }) => {
    if (!guardStatementExtractionFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }
  },
});
